<template>
  <div>
    <b-card-actions
      :show-loading="fetching"
      action-collapse
      title="Notas fiscais recebidas pendentes"
    >
      <b-alert
        :show="hasError"
        variant="danger"
        class="mb-1"
      >
        <div class="alert-body">
          {{ $t('Não foi possível carregar as notas fiscais recebidas pendentes') }}
        </div>
      </b-alert>
      <b-table
        v-if="!hasError"
        ref="pending-received-invoices-table"
        show-empty
        responsive
        striped
        class="bordered"
        no-local-sorting
        :empty-text="$t('Sem notas fiscais recebidas pendentes')"
        :fields="fields"
        :items="summaries"
        :sort-by.sync="sorting.sortBy"
        :sort-desc.sync="sorting.sortDesc"
        @sort-changed="getData"
      >
        <template #cell(storeName)="row">
          {{ row.item.storeName }}
        </template>
        <template #cell(pendingCount)="row">
          <e-router-link
            :title="$t('Ver notas fiscais recebidas pendentes da loja')"
            :to="{
              name: 'invoice-received-list',
              query: {
                storeId: String(row.item.storeId),
                status: 'Pending',
                model: 'NFE',
                applySalableCfops: 'true',
              },
            }"
            :value="`${row.item.pendingCount}`"
          />
        </template>
        <template #cell(totalValue)="row">
          {{ row.item.totalValue | currency }}
        </template>

        <template #custom-foot>
          <tr v-if="paging.rowCount > 0">
            <th class="text-right">
              {{ $t('Total') }}
            </th>
            <th class="text-center">
              {{ totalPendingCount }}
            </th>
            <th class="text-right">
              {{ totalPendingValue | currency }}
            </th>
          </tr>
        </template>
      </b-table>
      <b-row v-if="!hasError">
        <b-col>
          <e-pagination-summary
            :current-page="paging.currentPage"
            :per-page="paging.pageSize"
            :total="paging.rowCount"
            :total-on-page="paging.rowsInCurrentPage"
          />
        </b-col>
        <b-col>
          <b-pagination
            v-model="paging.currentPage"
            align="right"
            :total-rows="paging.rowCount"
            :per-page="paging.pageSize"
            aria-controls="pending-received-invoices-table"
            @change="pageChange"
          />
        </b-col>
      </b-row>
    </b-card-actions>
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BAlert, BPagination,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { mapActions, mapState } from 'vuex'
import { EPaginationSummary } from '@/views/components'
import ERouterLink from '@/views/components/ERouterLink.vue'

export default {
  components: {
    BCardActions,
    BTable,
    BRow,
    BCol,
    BAlert,
    BPagination,
    EPaginationSummary,
    ERouterLink,
  },

  data() {
    return {
      fetching: false,
      hasError: false,
    }
  },

  computed: {
    ...mapState('pages/dashboard/pendingReceivedInvoices', {
      summaries: 'summaries',
      summaryFields: 'summaryFields',
      paging: 'paging',
      sorting: 'sorting',
    }),

    totalPendingCount() {
      return this.summaryFields?.pendingCount?.value || 0
    },

    totalPendingValue() {
      return this.summaryFields?.totalValue?.value || 0
    },

    fields() {
      return [
        {
          label: this.$t('Loja'),
          key: 'storeName',
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: this.$t('Qtd pendentes'),
          key: 'pendingCount',
          class: 'text-center',
          thStyle: { width: '140px' },
          sortable: true,
        },
        {
          label: this.$t('Valor total'),
          key: 'totalValue',
          thClass: 'text-center',
          tdClass: 'text-right',
          thStyle: { width: '160px' },
          sortable: true,
        },
      ]
    },
  },

  async mounted() {
    await this.getData()
  },

  methods: {
    ...mapActions('pages/dashboard/pendingReceivedInvoices', [
      'fetchPendingInvoices',
      'setCurrentPage',
    ]),

    async getData() {
      this.$nextTick(async () => {
        try {
          this.fetching = true
          this.hasError = false
          await this.fetchPendingInvoices()
        } catch (error) {
          this.hasError = true
          this.showGenericError({ error })
        } finally {
          this.fetching = false
        }
      })
    },

    pageChange(currentPage) {
      this.setCurrentPage(currentPage)
      this.getData()
    },
  },
}
</script>

<style></style>
